import { render, staticRenderFns } from "./payLoading.vue?vue&type=template&id=16b967a2&"
import script from "./payLoading.vue?vue&type=script&lang=js&"
export * from "./payLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports